
import { useState } from 'react';
import { TableCell, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { DateTime } from 'luxon';
import { ReportDetail } from '@/types/salary';
import { RejectionReasonModal } from '../RejectionReasonModal';

interface TeacherReportTableRowProps {
  report: ReportDetail;
}

export function TeacherReportTableRow({ report }: TeacherReportTableRowProps) {
  const [showRejectionModal, setShowRejectionModal] = useState(false);

  const renderStatusCell = () => {
    switch (report.status) {
      case 'APPROVED':
        return <span className="text-green-600">✓</span>;
      case 'REJECTED':
        return (
          <Button
            variant="destructive"
            size="sm"
            onClick={() => setShowRejectionModal(true)}
          >
            ไม่อนุมัติ
          </Button>
        );
      case 'WAITING':
      default:
        return '-';
    }
  };

  return (
    <>
      <TableRow>
        <TableCell>
          {DateTime.fromISO(report.teaching_date).toFormat('d/M/yyyy')}
        </TableCell>
        <TableCell>
          <div>
            {report.class_type} {report.is_inter ? " Inter" : ""}
            {report.is_special_class && <div className="text-xs text-muted-foreground">คลาสพิเศษ</div>}
          </div>
        </TableCell>
        <TableCell>{report.tier}</TableCell>
        <TableCell>
          {report.grade === "primary" ? "ประถม" : 
           report.grade === "high_school" ? "มัธยม" : "พิเศษ"}
        </TableCell>
        <TableCell>
          {`${report.student_full_name} (${report.student_nickname})`}
        </TableCell>
        <TableCell className="text-center">
          {report.is_late_submit ? "✓" : "-"}
        </TableCell>
        <TableCell className="text-center">
          {report.is_late_beyond_2_days ? "✓" : "-"}
        </TableCell>
        <TableCell className="text-center">
          {report.sheet_approve_status === 'APPROVED' ? (
            <span>มี</span>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell className="text-center">
          {report.learning_status === "น้องไม่เข้าเรียน (ลากะทันหัน)" && report.sudden_leave_hours_deducted ? "✓" : 
           report.learning_status === "น้องไม่เข้าเรียน (ลากะทันหัน)" && !report.sudden_leave_hours_deducted ? (
            <span className="text-red-500">✗</span>
           ) : "-"}
        </TableCell>
        <TableCell className="text-center">
          {renderStatusCell()}
        </TableCell>
        <TableCell className="text-right">{report.duration}</TableCell>
        <TableCell className="text-right">
          {report.salary.toLocaleString()}
        </TableCell>
      </TableRow>

      <RejectionReasonModal
        isOpen={showRejectionModal}
        onClose={() => setShowRejectionModal(false)}
        rejectionReason={report.rejection_reason || 'ไม่มีเหตุผลที่ระบุ'}
      />
    </>
  );
}
